// extracted by mini-css-extract-plugin
module.exports = {"container":"album_container__2-cP3","gallery":"album_gallery__1hh_u","topBar":"album_topBar__3GKKW"};